import React from 'react'
import { Link } from 'react-router-dom'
import { Tooltip } from 'antd'
import classnames from 'classnames'

import styles from './styles.less'

const IconLinkButton = ({ to, icon, tooltipText, text, className }) => {
  if (tooltipText) {
    return (
      <Tooltip title={tooltipText} placement='topRight'>
        <Link to={to} className={className}>
          {icon}
        </Link>
      </Tooltip>
    )
  }
  return (
    <Link to={to} className={classnames(styles.link_icon, className)}>
      {icon} <span>{text}</span>
    </Link>
  )
}

export default IconLinkButton
